
import {NavigationMockApi} from 'app/shared/routes/navigation/api';

export const mockApiServices = [
    NavigationMockApi,
];
